


































import Vue, { PropType } from 'vue';
import { CourseraCourse, CourseraPartner } from '~/models/coursera';

export default Vue.extend({
    name: 'CourseCard',
    props: {
        course: {
            type: Object as PropType<CourseraCourse>,
            required: true,
        },
        width: {
            type: Number,
            required: true,
        },
    },
    computed: {
        courseType(): string {
            switch (this.course.contentType) {
                case 'Course':
                    return 'Course';
                case 'Specialization':
                    return 'Specialization';
                default:
                    return 'Course';
            }
        },
        partner(): CourseraPartner | {} {
            if (this.course.partners && this.course.partners.length) return this.course.partners[0];
            return {};
        },
    },
});
